@if (loading$ | async) {
  <ng-container *ngTemplateOutlet="loading"></ng-container>
} @else {
  <ng-container [formGroup]="form" data-test="purchase-order--form">
    <mat-card data-test="purchase-order--card">
      <div data-test="purchase-order--container">
        <div  data-test="purchase-order--po-number-labels" class="purchase-order--labels" >
          <label class="purchase-order--label h-400" for="poNumber">{{ 'checkoutPO.poNumber' | cxTranslate }}</label>
          @if (isReadonly()){
          <a class="purchase-order__edit-link" [routerLink]="{ cxRoute: deliveryModeRoute } | cxUrl"
             data-test="purchase-order--po-number-edit-link">
            <mat-icon svgIcon="edit"></mat-icon>
            <span>{{ 'checkoutReview.editShippingAndPayment' | cxTranslate }}</span>
          </a>
          }
        </div>
        <input data-test="purchase-order--input" id="poNumber" #poNumberRef
          class="form-control"
          formControlName="poNumber"
          type="text"
          [placeholder]="purchaseOrderNumberPlaceholder$ | async | cxTranslate"
        />
        <cx-form-errors [control]="form.get('poNumber')" data-test="purchase-order--errors" />
      </div>
    </mat-card>

    @if (hasUserPurchaseNumber$ | async) {
      <mat-card data-test="purchase-order--open-text-card">
        <div data-test="purchase-order--open-text-container">
          <div  data-test="purchase-order--open-text-labels" class="purchase-order--labels" >
          <label class="purchase-order--label h-400" data-test="purchase-order--open-text-label"
          >{{ 'dpCheckoutOrderComment.orderCommentHeadline' | cxTranslate }}</label>
        </div>
          <input data-test="purchase-order--open-text-input"
            class="form-control"
            formControlName="orderOpenText"
            type="text"
            [placeholder]="'dpCheckoutOrderComment.orderCommentLabel' | cxTranslate"
          />
          <cx-form-errors [control]="form.get('orderOpenText')" data-test="purchase-order--open-text-errors" />
        </div>
      </mat-card>
    }
  </ng-container>
}

<ng-template #loading>
  <mat-card class="mb-3"  data-test="purchase-order--loader-cart">
    <div class="cx-spinner" data-test="purchase-order--loader-container">
      <cx-spinner data-test="purchase-order--spinner"></cx-spinner>
    </div>
  </mat-card>
</ng-template>
